import { Link } from "react-router";
import { Search, XIcon } from "lucide-react";
import { useId } from "react";
import { useTranslation } from "react-i18next";

export function ProductsHeader({ filter, setFilter }: { filter: string; setFilter: (value: string) => void }) {
  const { t } = useTranslation();
  const filterInputId = useId();
  return (
    <div className="flex flex-col items-center pb-20">
      <Link to="./../" className="mb-6 mt-8 text-dynamic-primary">
        {t("Zurück zur Startseite")}
      </Link>
      <h1 className="text-center text-4.5xl sm:text-7xl">{t("Unser Testangebot")}</h1>
      <div className="mx-auto mt-10 flex items-center gap-2 rounded-xl border border-gray-200 bg-gray-100 px-4">
        <Search aria-hidden="true" className="w-5" />
        <label htmlFor={filterInputId} className="sr-only">
          {t("Suche nach einem Test")}
        </label>
        <input
          id={filterInputId}
          type="search"
          className="flex-1 bg-transparent p-2 outline-none md:min-w-[400px]"
          placeholder={t("Suche nach einem Test")}
          onChange={(e) => setFilter(e.target.value)}
          value={filter}
        />
        {filter ? (
          <button type="button" onClick={() => setFilter("")} aria-label={t("Suche zurücksetzen")}>
            <XIcon aria-hidden="true" className="w-4" />
          </button>
        ) : (
          <div className="w-4" />
        )}
      </div>
    </div>
  );
}
